import { AHIcon, AHText, Box, useTime } from "arkh";
import { useTimeZone } from "../../OS/Timezone";
import { DateTime } from "luxon";
import { View } from "react-native";

function Clock() {
  const time = useTime(6000);

  const tz = useTimeZone();
  return time.setZone(tz).toLocaleString(DateTime.TIME_24_SIMPLE);
}

function Timezone() {
  return useTimeZone();
}

export function TimezoneIndicator() {
  const tintColor = "text-inverted";
  return (
    <View>
      <Box
        style={{
          flexDirection: "row",
          alignItems: "flex-start",
        }}
        color={"darkerText"}
        space="xsmall"
        spaceHorizontal="small"
        cornerRadius="small"
      >
        <AHText color={tintColor}>
          <Timezone />
        </AHText>
        <AHText spaceLeft="xsmall" color={tintColor}>
          <Clock />
        </AHText>
        <AHIcon
          spaceLeft="xsmall"
          type="timezone"
          size="xsmall"
          color={tintColor}
        />
      </Box>
    </View>
  );
}
